import { render } from "./Posting.vue?vue&type=template&id=47a57c10&scoped=true"
import script from "./Posting.vue?vue&type=script&lang=js"
export * from "./Posting.vue?vue&type=script&lang=js"

import "./Posting.vue?vue&type=style&index=0&id=47a57c10&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a57c10"]])

export default __exports__